import { createAction } from 'redux-actions';

export const createUpdateAction = type =>
  createAction(type, (id, data) => ({
    id,
    ...data,
  }));

